import {markFailureShown} from "./markFailureShown";
import {clientLog} from "../clientLog";

/**
 * Fire-and-forget (DE-1817): tells the backend the job's failure was shown. A throwing or rejecting mark write
 * never reaches the caller, so it cannot break rendering.
 *
 * @param {string} jobId - The failed job.
 */
export const recordFailureShown = (jobId) => {
    try {
        Promise.resolve(markFailureShown(jobId)).catch(() => {});
    } catch (error) {
        clientLog('warn', `${jobId} - failure-shown mark failed: ${error}`, 'fileuploadoperation');
    }
};
